import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TH2418Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TH2418IconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="18"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <g clipPath="url(#clip0_1813_590)">
        <rect width="24" height="18" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 12H24V18H0V12Z"
          fill="#F50101"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H24V4.5H0V0Z"
          fill="#F50101"
        />
        <path
          d="M0 4.5H-1.5V6V12V13.5H0H24H25.5V12V6V4.5H24H0Z"
          fill="#3D58DB"
          stroke="white"
          strokeWidth="3"
        />
      </g>
      <defs>
        <clipPath id="clip0_1813_590">
          <rect width="24" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TH2418Icon;
